"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
var HeaderWrapper = function HeaderWrapper(Component) {
  var _class, _class2;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2() {
      var _this;
      _classCallCheck(this, _class2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper(this, _class2, [].concat(args));
      _this.onChangeTargetLanguageId = function (languageId) {
        _state.AppUI.user.set('targetLanguageId', languageId);
        _state.AppUI.authUserStore.update({
          data: {
            targetLanguageId: languageId
          }
        }, function () {
          return _this.afterUpdateAuthUserStore(languageId);
        });
        _state.TreeUI.loadTree(_constants.Constants.STORY_TREE_BY_LANGUAGE[languageId]);
        _state.VocabUI.clearSelectedWords();
        if (languageId === 'DE') {
          _state.TreeUI.loadTree('trivia');
        }
        _state.VocabUI.clearFilterCache();
        if (_state.AppUI.routeStore.routeName === 'vocab.home') {
          _state.VocabUI.getWords();
          _state.VocabUI.getLearnedByLevel(_state.AppUI.targetLanguageId);
        }
        if (_state.AppUI.routeStore.routeName === 'trivia.home') {
          _state.AppUI.routeStore.routeToNamed('reviews.home');
        }
        if (_state.AppUI.routeStore.routeName === 'vocab.word') {
          _state.AppUI.routeStore.routeToNamed('vocab.home', {
            page: 1
          });
        }
        if (_state.AppUI.routeStore.routeName.startsWith('grammar')) {
          _state.TreeUI.loadTree(_constants.Constants.GRAMMAR_TREE_BY_LANGUAGE[languageId]);
          _state.AppUI.routeStore.routeToNamed('grammar', {
            page: 1
          });
        }
        if (_state.AppUI.routeStore.routeName === 'stories.show') {
          _state.AppUI.routeStore.routeToNamed('stories.home');
        }
        if (_state.AppUI.routeStore.routeName === 'reviews.index') {
          _state.AppUI.cardStore.clearIndexData();
        }
        if (_state.AppUI.routeStore.routeName === 'stories.home') {
          var el = document.getElementsByClassName('app')[0];
          el.scrollTop = 0;
        } else {
          _state.AppUI.set('contentTreeScrollPosition', 0);
        }
      };
      _this.afterUpdateAuthUserStore = function (languageId) {
        _state.AppUI.createEvent('header - switch languages', {
          language_id: languageId
        });
        _state.AppUI.reviewDeckStore.getIndex({});
        _state.AppUI.loadUser();
      };
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showMemrevMembershipButton",
      get: function get() {
        return !this.simplifiedHeader && !_state.AppUI.user.anyAdmin && _state.AppUI.siteIsMemrev && !_state.AppUI.user.isMember;
      }
    }, {
      key: "simplifiedHeader",
      get: function get() {
        return _state.AppUI.routeStore.routeName === 'memberships.create';
      }
    }, {
      key: "memrevHomeRoute",
      get: function get() {
        var _AppUI$user, _AppUI$user2;
        if (_state.AppUI.userIsLoaded && (_AppUI$user = _state.AppUI.user) !== null && _AppUI$user !== void 0 && (_AppUI$user = _AppUI$user.site) !== null && _AppUI$user !== void 0 && _AppUI$user.signedInHomePageRoute) {
          return _state.AppUI.user.site.signedInHomePageRoute;
        } else if (!_state.AppUI.userIsLoaded && (_AppUI$user2 = _state.AppUI.user) !== null && _AppUI$user2 !== void 0 && (_AppUI$user2 = _AppUI$user2.site) !== null && _AppUI$user2 !== void 0 && _AppUI$user2.signedOutHomePageRoute) {
          return _state.AppUI.user.site.signedOutHomePageRoute;
        }
        return 'memrev.home';
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          memrevHomeRoute: this.memrevHomeRoute,
          onChangeTargetLanguageId: this.onChangeTargetLanguageId,
          showMemrevMembershipButton: this.showMemrevMembershipButton,
          simplifiedHeader: this.simplifiedHeader,
          showStoriesNewLabel: _state.TreeUI.showStoriesNewLabel
        }));
      }
    }]);
  }(_react["default"].Component), _applyDecoratedDescriptor(_class2.prototype, "showMemrevMembershipButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showMemrevMembershipButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "simplifiedHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "simplifiedHeader"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "memrevHomeRoute", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "memrevHomeRoute"), _class2.prototype), _class2)) || _class;
};
HeaderWrapper.displayName = 'HeaderWrapper';
var _default = exports["default"] = HeaderWrapper;